import { Grid, CircularProgress, Typography } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';
import React, { useState, useEffect } from 'react';

const LivrosBiblioteca = () => {
  const [livros, setLivros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
	const { isMobile, isDesktop } = useDevice();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://cnm.org.br/api/biblioteca?limit=&area_tecnica=2&sort=created_at&order=desc&search=drogas');
        const data = await response.json();
        if (data.biblioteca && Array.isArray(data.biblioteca.data)) {
          // Filtrar livros publicados após 2017
          const filteredLivros = data.biblioteca.data.filter(livro => parseInt(livro.ano) > 2016);
          setLivros(filteredLivros);
        } else {
          setError('Os dados recebidos não estão no formato esperado');
        }
      } catch (error) {
        console.error('Erro ao buscar livros:', error);
        setError('Erro ao carregar os livros. Por favor, tente novamente mais tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const openPdf = (link) => {
    window.open(link, '_blank');
  };

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '78vh' }}>
        <CircularProgress />
      </Grid>
    );
  }

  if (error) {
    return (
      <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '80vh' }}>
        <Typography variant="h6" color="error">{error}</Typography>
      </Grid>
    );
  }

  return (
    <Grid container direction="column" justifyContent="center"  sx={{  padding: '20px', backgroundColor: '#E5EBEF' }}>
      <Typography sx={{ textAlign: 'center', paddingTop: '2em', fontSize: '2em', fontWeight: '600' }}>Biblioteca</Typography>
      <Grid container spacing={3} justifyContent="center" alignItems="center" sx={{ marginTop: '20px', marginBottom: isDesktop ? '10em' : '' }}>
        {livros.map(livro => (
          <Grid item key={livro.id}>
            <img
              src={livro.imagem.trim() !== '' ? livro.imagem : 'https://cnm.org.br/img/img-padrao-biblioteca.jpg'}
              alt={livro.titulo}
              onClick={() => openPdf(`https://cnm.org.br${livro.link}`)}
              style={{ cursor: 'pointer', width: '220px', height: '300px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', transition: 'transform 0.3s ease-in-out', '&:hover': {transform: 'scale(1.05)'	} }}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default LivrosBiblioteca;
